module.exports = __webpack_public_path__ + "img/12.5c8c719a.jpg";